import { Link } from "react-router-dom";
import SectionHeader from "../components/ui/SectionHeader";
import { services } from "../data/siteData";

function ServicesPage() {
  return (
    <section className="page-section">
      <div className="shell">
        <SectionHeader kicker="Sluzby" title="Elektro prace pro domy, byty a firmy">
          Strucny prehled praci. Bez preplacaneho layoutu, bez internich admin prvku.
        </SectionHeader>

        <div className="mt-10 grid gap-5 md:grid-cols-2">
          {services.map((service) => (
            <article key={service.title} className="card p-6">
              <h2 className="text-xl font-bold text-white">{service.title}</h2>
              <p className="mt-3 text-sm leading-6 text-slate-300">{service.description}</p>
              <div className="mt-5 flex items-center justify-between border-t border-cyan-300/10 pt-4">
                <span className="text-sm text-slate-400">Orientacne</span>
                <span className="text-sm font-semibold text-cyan-300">{service.price}</span>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 rounded-lg border border-cyan-300/15 bg-[#07131d] p-6 text-white sm:flex sm:items-center sm:justify-between sm:gap-6">
          <div>
            <h2 className="text-xl font-bold">Potrebujete nacenit konkretni praci?</h2>
            <p className="mt-2 text-sm leading-6 text-slate-300">Poslete popis a ozvu se s dalsim postupem.</p>
          </div>
          <Link to="/kontakt" className="mt-5 btn-primary sm:mt-0">
            Kontaktovat
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ServicesPage;
